(function($) {
  
	// Open Mobile Nav
  $('.hamburger').click(function(e){
		$(this).toggleClass('is-active');
		$('body, .navbar_mobile').toggleClass('active');
		
	});

  //Open Submenu in mobile nav
	$('.sub-menu_trigger').click(function(){
		$(this).toggleClass('active');
		$(this).next().toggleClass('active');
	});	

	//Close Commerical Mobile Nav when menu item clicked
	$('.navbar_mobile.commercial ul li a').click(function(){
		$('body, .navbar_mobile').removeClass('active');
	});

	//check if header is sticky so mobile menu position can be adjusted for no top bar
	const header = document.querySelector(".header")
	const topBar = document.querySelector(".top_bar")
	const navbarMobile = document.querySelector(".navbar_mobile");
	const observer = new IntersectionObserver( ([e]) => navbarMobile.classList.toggle("is-sticky", e.intersectionRatio < 1),
	  { threshold: [1] }
	);
	const topBarObserver = new IntersectionObserver( ([e]) => topBar.classList.toggle("is-sticky", e.intersectionRatio < 1),
	  { threshold: [1] }
	);

	observer.observe(header);
	topBarObserver.observe(topBar);
	

	//Accordion
	$('.accordion_title, .accordion_sub_title').click(function(){
	  	$(this).parent().toggleClass('active');
	  	$(this).find('.plus').toggle();
	  	$(this).find('.minus').toggle();
	});



  //Product Slider
  $('.slider_featured-product').slick({
     infinite: true,
  	  slidesToShow: 3,
  	  prevArrow: $('.slider_nav-prev'),
	  nextArrow: $('.slider_nav-next'), 
  	  responsive: [
     	{
	      breakpoint: 1200,
	      settings: {
	        slidesToShow: 2,
	       
	      }
      },
      {
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        arrows: false,
	        dots: true,
	        
	      }
      },
      {
	      breakpoint: 576,
	      settings: {
	        slidesToShow: 1,
	        arrows: false,
	        dots: true,
	       
	      }
      },
     ]
  });

	//Project Gallery 
	$('.project_gallery-slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
	  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	  var i = (currentSlide ? currentSlide : 0) + 1;
	  $('.slide_count').text(i + '/' + slick.slideCount);
	});
	$('.project_gallery-slider').slick({
		prevArrow: $('.slider_nav-prev'),
	  	nextArrow: $('.slider_nav-next'),
	  	responsive: [
     	
      {
	      breakpoint: 576,
	      settings: {
	        arrows: false,
	        dots: true,
	       
	      }
      },
     ],  
	});

  //Add required to gravity form phone number / emails fields based on how would you like to contact us field
  $('.gf_contact_type').on('change', function(e){
  	var contactType 		= e.target.value;
  	var phoneNumberLabel = $('.gf_phone_number label');
  	var emailLabel 		= $('.gf_email label');
  	var requriredHTML 	= '<span class="gfield_required"><span class="gfield_required gfield_required_asterisk">*</span></span>';
  	

  	if(contactType === 'phone'){
  		$(phoneNumberLabel).append(requriredHTML);
  		$('.gf_email label .gfield_required').remove();
  	}else if(contactType === 'email') {
  		$(emailLabel).append(requriredHTML);
  		$('.gf_phone_number label .gfield_required').remove();
  	} else {
  		$('.gf_email label .gfield_required').remove();
  		$('.gf_phone_number label .gfield_required').remove();
  	}
  });

  //Add / Remove Validation Messages / Classes after form validation error has occured
  $(document).on('gform_post_render', function(event, form_id, current_page){
  	

	  	if ( $('div.gform_validation_error').length > 0 ) {
			$('.gf_contact_type').on('change', function(e){
				var contactType 		= e.target.value;
				var phoneNumberLabel = $('.gf_phone_number label');
				var emailLabel 		= $('.gf_email label');
				var requriredHTML 	= '<span class="gfield_required"><span class="gfield_required gfield_required_asterisk">*</span></span>';

				if(contactType === 'phone'){
					$(phoneNumberLabel).append(requriredHTML);
					$('.gf_email label .gfield_required').remove();
					$('.gf_email .validation_message').remove();
					$('.gf_email').removeClass('gfield_error');
				}else if(contactType === 'email') {
					$(emailLabel).append(requriredHTML);
					$('.gf_phone_number label .gfield_required').remove();
					$('.gf_phone_number .validation_message').remove();
					$('.gf_phone_number').removeClass('gfield_error');
				} else {
					$('.gf_email label .gfield_required, .gf_phone_number label .gfield_required').remove();
					$('.gf_email .validation_message, .gf_phone_number .validation_message').remove();
					$('.gf_email, .gf_phone_number').removeClass('gfield_error');
					
				}
			});
		}

		if ( $('div.validation_message', '#gform_' + form_id).length > 0  ) {
     		$('.aws_upload').prepend("<div class='alert alert_warning'>If you have uploaded images already you don't have to upload them again.</div>");
 		}

		
	

  });

	//Blog Category Link to url
	$('#cat').on('change', function(e) {
		var url = $(this).val();
		var selected = $(this).find('option:selected');
		if (url) {
			window.location = url;
		}
		return false;
	});

	//Project Filtering




})( jQuery );